// extracted by mini-css-extract-plugin
module.exports = {"titleCase":"_4060495"};